import { StringWidget } from 'angular2-schema-form';
import { Component } from '@angular/core';

@Component({
  selector: 'app-sf-email-widget',
  templateUrl: './email.widget.html'
})
export class MyEmailWidgetComponent extends StringWidget {

  showError(errors) {

    const uniqEs6 = (arrArg) => {
      const findArray = [];
      return arrArg.filter((elem) => {
        if (findArray.indexOf(elem.code) >= 0) {
          return false;
        } else {
          findArray.push(elem.code);
          return true;
        }
      });
    };

    return uniqEs6(errors);
  }
}



// WEBPACK FOOTER //
// ./src/shared/form-widgets/email/email.widget.ts